import { ApolloProvider } from '@apollo/client'
import App from 'components/App'
import Router from 'components/Router'
import { createRoot } from 'react-dom/client'

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <App
    ApolloProvider={ ApolloProvider }
    Router={ Router }
  />,
)
